import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromApp from '../../app.reducer';
import { ContribService } from './contrib.service';
import { switchMap, map, flatMap, catchError } from 'rxjs/operators';
import { CurrentUser } from 'app/services/currentUser.service';
import { HeaderComponent } from 'app/header/header.component';

@Component({
  selector: 'app-contrib',
  templateUrl: './contrib.component.html',
  styleUrls: ['./contrib.component.scss'],
  providers: [HeaderComponent],

})
export class ContribComponent implements OnInit {
  done: boolean;
  isMobile;
  projectId;
  invitationToken;
  projectInfo;
  owner;
  guest;
  canEdit;
  Load;
  isguest: boolean;
  isValid = true;

  constructor(
    private store: Store<fromApp.AppState>,
    private contribService: ContribService,
    private currentUser: CurrentUser,
    private route: ActivatedRoute,
    private header: HeaderComponent ) {

    this.projectId = this.route.snapshot.paramMap.get('uuid');
    this.invitationToken = this.route.snapshot.queryParamMap.get('token');
    this.done = this.route.snapshot.queryParamMap.get('done') === 'true';
  }

  ngOnInit() {
    this.store.select('shared').subscribe(store => {
      this.isMobile = store.isMobile;
    });
    this.isguest = this.currentUser.get() ? this.currentUser.get().guest : false;
    if (!this.header.isLoggedIn()) {
      this.currentUser.createUser().subscribe(d => {
        this.currentUser.set(d);
        this.isguest = this.currentUser.get() ? this.currentUser.get().guest : false;
        this.loadStoryData();
      });
    } else {
      this.loadStoryData();
    }
  }

  loadStoryData() {
    this.currentUser.acceptShare(this.invitationToken).pipe(
      flatMap(() => this.contribService.getProjectInfo(this.projectId)),
      switchMap( project =>
      this.contribService.getOwnerInfo(project.owner_id).pipe(
            map(owner => ({uuid: this.invitationToken, project, owner }))
        )
      ),
    ).subscribe(result => {
            this.isValid = true;
            this.projectInfo = result.project;
            this.owner = result.owner;
            this.contribService._owner.next(result);
          }, err => {this.isValid = false; }
    );
  }
}
